<div class="document-type-tree-select">
  <div class="selected-document-type mb-2" *ngIf="selectedDocumentType || documentTypeId">
    <strong>{{ selectedDocumentTypeLabel() }}</strong>
    <button type="button" class="btn btn-link btn-sm py-0 selected-document-type-clear" title="Clear document type" [disabled]="!editable" (click)="clearSelectedDocumentType()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="input-group input-group-sm mb-2">
    <input
      #documentTypeFilterInput
      type="text"
      class="form-control"
      [placeholder]="placeholder"
      [ngModel]="filterText"
      autocomplete="off"
      autocorrect="off"
      spellcheck="false"
      [disabled]="!editable"
      (ngModelChange)="applyFilter($event)"
      (keydown.enter)="$event.preventDefault()"
    />
    <div class="input-group-append">
      <button
        type="button"
        class="btn btn-outline-secondary"
        *ngIf="filterText"
        [disabled]="!editable"
        (click)="documentTypeFilterInput.value = ''; clearFilter()">
        Clear Text
      </button>
    </div>
  </div>

  <div class="document-type-tree-loading text-center py-3" *ngIf="loading">
    <i class="fas fa-spinner fa-spin"></i>
  </div>

  <div class="document-type-tree" *ngIf="!loading" [style.maxHeight.px]="maxHeight">
    <ng-container *ngTemplateOutlet="documentTypeNodesTemplate; context: { nodes: visibleDocumentTypeTree, level: 0 }"></ng-container>
  </div>
</div>

<ng-template #documentTypeNodesTemplate let-nodes="nodes" let-level="level">
  <div class="document-type-node" *ngFor="let node of nodes" [style.paddingLeft.px]="level * 14">
    <div
      class="document-type-row"
      [class.document-type-row-selected]="selected(node)"
      (click)="selectDocumentType(node)">
      <button
        type="button"
        class="btn btn-link btn-sm p-0 text-left document-type-expand-button"
        [class.invisible]="documentTypeArray(node.children).length < 1"
        (click)="toggleNode(node, $event)">
        <i class="fas" [ngClass]="{ 'fa-chevron-down': nodeExpanded(node), 'fa-chevron-right': !nodeExpanded(node) }"></i>
      </button>

      <button
        type="button"
        class="btn btn-link btn-sm p-0 text-left document-type-select-button"
        [disabled]="!editable"
        [title]="node.full_name || node.label">
        <span class="document-type-name">{{ node.name }}</span>
        <span class="document-type-prefix text-muted" *ngIf="displayPrefix(node) as prefix">{{ prefix }}</span>
      </button>
    </div>

    <ng-container *ngIf="documentTypeArray(node.children).length > 0 && nodeExpanded(node)">
      <ng-container *ngTemplateOutlet="documentTypeNodesTemplate; context: { nodes: documentTypeArray(node.children), level: level + 1 }"></ng-container>
    </ng-container>
  </div>
</ng-template>
